/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import type { FC } from 'react';

import { ChangeSubscribersListContainerStyled } from '@pages/WizardAdditionalReports/components/styled/ChangeSubscribersModalStyled';
import { IEditableId } from '@pages/WizardAdditionalReports/types/wizardAdditionalReportsActionTypes';

import { WizardAdditionalReportsChangeSubscribersListItem } from './WizardAdditionalReportsChangeSubscribersListItem';

export interface IWizardAdditionalReportsChangeSubscribersListProps {
    subscribers: IEditableId[];
    searchValue: string;
    switchSubscriber?: (subscriber: IEditableId) => void;
}

export const WizardAdditionalReportsChangeSubscribersList: FC<IWizardAdditionalReportsChangeSubscribersListProps> = (
    {
        subscribers,
        searchValue,
        switchSubscriber,
    },
) => {
    const subscribersList = subscribers.filter(subscriber =>
        !searchValue || subscriber.label.toLowerCase().includes(searchValue.toLowerCase()));

    return (
        <ChangeSubscribersListContainerStyled data-component='subscribers-list'>
            {
                subscribersList.map(subscriber => (
                    <WizardAdditionalReportsChangeSubscribersListItem key={subscriber.id}
                                                                      searchValue={searchValue}
                                                                      subscriber={subscriber}
                                                                      switchSubscriber={switchSubscriber}
                    />
                ))
            }
        </ChangeSubscribersListContainerStyled>
    );
};
